import { computed, ref } from 'vue';
import { flattenObj } from '@/helpers/util';

// Default values for data that varies depending on whether this is a
// 1st or 3rd-party request.
const contactInfoDefaults = {
  fromFirstName: null,
  fromLastName: null,
  fromOrganization: null,
  fromBirthDate: null,
  fromMedicareNumber: null,
  fromEmail: null,
  fromPhone: null,
  fromFax: null,
  fromAddressLine1: null,
  fromAddressLine2: null,
  fromCity: null,
  fromState: null,
  fromZip: null,
  onBehalfOfFirstName: null,
  onBehalfOfLastName: null,
  onBehalfOfBirthDate: null,
  onBehalfOfMedicareNumber: null,
  onBehalfOfAddressLine1: null,
  onBehalfOfAddressLine2: null,
  onBehalfOfCity: null,
  onBehalfOfState: null,
  onBehalfOfZip: null,
  externalCaseNumber: null
};
const recordDetailsDefaults = {
  attachments: [],
  comments: null,
  recordDateRanges: null,
  timelineOfRelease: null
};

export const is3rdParty = ref(null);

// The raw data for the FOIA request.
export const request = ref({
  firstParty: {
    contactInfo: { ...contactInfoDefaults },
    recordDetails: { ...recordDetailsDefaults }
  },
  thirdParty: {
    contactInfo: { ...contactInfoDefaults },
    recordDetails: { ...recordDetailsDefaults }
  },
  common: {
    otherDetails: {
      civilOrCriminalCaseNumber: null,
      certificationIsNotAParty: null,
      expeditedProcessingRequested: false,
      expeditionJustification: null,
      maxFeeAmount: null,
      feeWaiverJustification: null,
      feeWaiverRequested: false,
      nameOfTheCourt: null,
      recordCertificationRequested: false
    }
  }
});

/**
 * Data that varies depending on whether this is a 1st or 3rd-party request.
 */
export const nonCommonData = computed(() => request.value[is3rdParty.value ? 'thirdParty' : 'firstParty']);

/**
 * The request data formatted for final submission.
 */
export const formData = computed(() => ({
  ...flattenObj(request.value.common),
  ...flattenObj(nonCommonData.value),
  // Strip out url added previously
  attachments: nonCommonData.value.recordDetails.attachments
  // eslint-disable-next-line object-curly-newline
    .map(({ name, contentType, size, contents }) => ({ name, contentType, size, contents }))
}));
